
import { Pie } from 'react-chartjs-2';
import React, { useState, useEffect, useContext } from "react";
import { HueContext } from "../HueContext";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

export default function Transactions() {
  // Transaction data
  const [transactions, setTransactions] = useState([]);
  
        useEffect(() => {
  const loadTransactions = () => {
    const stored = JSON.parse(
      localStorage.getItem("spectraTransactions") || "[]"
    );
    setTransactions(stored);
  };

  loadTransactions();

  window.addEventListener("transactionsUpdated", loadTransactions);

  const interval = setInterval(loadTransactions, 2000);

  return () => {
    window.removeEventListener("transactionsUpdated", loadTransactions);
    clearInterval(interval);
  };
}, []);

  // Toggle state for Pie chart
  const [showChart, setShowChart] = useState(false);
  const hue = useContext(HueContext);
  // Calculate allocation for Pie chart
  const totalDeposits = transactions
    .filter(t => t.type === 'Deposit')
    .reduce((sum, t) => sum + t.amount, 0);

  const totalWithdrawals = transactions
    .filter(t => t.type === 'Withdrawal')
    .reduce((sum, t) => sum + t.amount, 0);
      
    const BuyOrders = transactions
    .filter(t => t.type === 'Buy')
    .reduce((sum, t) => sum + t.amount, 0);

const SellOrders = transactions
    .filter(t => t.type === 'Sell')
    .reduce((sum, t) => sum + t.amount, 0);

  const hasTransactionData = (totalDeposits + totalWithdrawals + BuyOrders + SellOrders) > 0;

  const allocationData = {
    labels: hasTransactionData
      ? ['Deposits', 'Withdrawals', 'Buy Orders', 'Sell Orders']
      : ['No Transactions Yet'],
    datasets: [
      {
        label: 'Transaction Allocation',
        data: hasTransactionData
          ? [totalDeposits, totalWithdrawals, BuyOrders, SellOrders]
          : [1],
        backgroundColor: hasTransactionData
          ? ['#00ff04a8', '#ff0800ff', '#00bfffcc', '#ffd700cc']
          : ['#444'],
        borderWidth: 1,
      },
    ],
  };


  

  return (
    <div
      style={{
        maxWidth: 900,
        margin: '32px auto',
        background: '#111',
        padding: 24,
        borderRadius: 12,
        color: '#fff',
        boxShadow: '0 0 20px rgba(255, 215, 0, 0.3)',
      }}
    >
      {/* Header with toggle button */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          
              <h2
                  style={{
                  marginTop: 0,
                  color: `hsl(${hue}, 100%, 60%)`,
                  transition: "color 0.1s linear"
                  
        }}
           >
       Transactions
              </h2>

        <button
          onClick={() => setShowChart(!showChart)}
          style={{
            padding: '8px 16px',
            borderRadius: 8,
            border: 'none',
            background: '#00bfff',
            color: '#fff',
            cursor: 'pointer',
            fontWeight: 'bold',
          }}
        >
          {showChart ? 'Hide Allocation' : 'Show Allocation'}
        </button>
      </div>

      {/* Pie chart */}
      {showChart && (
        <div style={{ marginTop: 24, maxWidth: 400 }}>
          <Pie data={allocationData} options={{
            responsive: true,
            maintainAspectRatio: true,
            plugins: {
              legend: {
                display: true,
                labels: { color: '#ffffff' }
              }
            }
          }} />
        </div>
      )}

      {/* Transactions Table */}
      {transactions.length === 0 ? (
        <p style={{ textAlign: 'center', marginTop: 24 }}>No transactions yet</p>
      ) : (
        <table
          style={{
            width: '100%',
            borderCollapse: 'collapse',
            marginTop: 16,
          }}
        >
          <thead>
            <tr>
              <th style={{ textAlign: 'left', padding: 12, borderBottom: '2px solid #555' }}>Date</th>
              <th style={{ textAlign: 'left', padding: 12, borderBottom: '2px solid #555' }}>Type</th>
              <th style={{ textAlign: 'right', padding: 12, borderBottom: '2px solid #555' }}>Amount</th>
            </tr>
          </thead>
          <tbody>
              {transactions.map((t, index) => (
                 <tr key={index}>
                <td style={{ padding: 12, borderBottom: '1px solid #333' }}>{t.date || '-'}</td>
                <td style={{ padding: 12, borderBottom: '1px solid #333' }}>{t.type || '-'}</td>
                <td style={{ padding: 12, textAlign: 'right', borderBottom: '1px solid #333' }}>
                  {typeof t.amount === 'number' ? `$${t.amount.toLocaleString()}` : '-'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
